// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const APPLY_COLUMN_MAPPING_STEP_SHAPES = [
  {
    stepType: PipelineStepType.APPLY_COLUMN_MAPPING,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      outputColumns: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'taggedUnion',
          required: true,
          tagKey: 'matchBy',
          choices: [
            {
              kind: 'shape',
              required: true,
              fields: {
                matchBy: {
                  kind: 'string',
                  required: true,
                  value: 'POSITION'
                },
                columnPosition: {
                  kind: 'integer',
                  required: true,
                  minValue: 1
                },
                displayName: {
                  kind: 'string',
                  required: false
                },
                systemName: {
                  kind: 'string',
                  required: false,
                  pattern: '^$|^[a-z_][a-z0-9_]{0,62}$'
                },
                createEmptyColumnIfNotFound: {
                  kind: 'boolean',
                  required: false
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                matchBy: {
                  kind: 'string',
                  required: true,
                  value: 'NAME'
                },
                caseSensitive: {
                  kind: 'boolean',
                  required: true
                },
                displayName: {
                  kind: 'string',
                  required: true
                },
                systemName: {
                  kind: 'string',
                  required: false,
                  pattern: '^$|^[a-z_][a-z0-9_]{0,62}$'
                },
                createEmptyColumnIfNotFound: {
                  kind: 'boolean',
                  required: false
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                matchBy: {
                  kind: 'string',
                  required: true,
                  value: 'REGEX'
                },
                regEx: {
                  kind: 'string',
                  required: true
                },
                displayName: {
                  kind: 'string',
                  required: false
                },
                systemName: {
                  kind: 'string',
                  required: false,
                  pattern: '^$|^[a-z_][a-z0-9_]{0,62}$'
                },
                createEmptyColumnIfNotFound: {
                  kind: 'boolean',
                  required: false
                }
              }
            }
          ]
        }
      },
      keepUnmappedColumns: {
        kind: 'boolean',
        required: false
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
